import { Brand } from "./brand.js";

export const terms = [
  "ワンピ",
  "トップス",
  "ボトムス",
  "シューズ",
  "アクセ",
] as const;
export type Term = (typeof terms)[number];
export interface ChildCheckStats {
  owned: number;
  total: number;
  comp: boolean;
}
export interface RowState {
  selected: boolean;
}
export interface ParentRowState {
  open: boolean;
  selected: boolean;
}

export interface Item {
  id: string;
  name: string;
  check: boolean;
  sec: string;
  star: string;
  brand: Brand;
  term: Term;
  itemID: string;
  qr: string;
  point: string;
  url: string;
  parentID: string;
  element: HTMLTableRowElement;
  rowState: RowState;
  tags?: string[];
  itemType?: "normal" | "set";
  setItems?: Item[];
  setQR?: string;
}

export interface ParentItem {
  id: string;
  name: string;
  childCheckState: ChildCheckStats;
  sec: string;
  star: string;
  brand: Brand;
  itemID: string;
  qr: string;
  element: HTMLTableRowElement;
  children: Item[];
  rowState: ParentRowState;
  tags?: string[];
}

export const parentItemFlat = (parentItems: ParentItem[]): Item[] => {
  return parentItems.flatMap((parentItem: ParentItem) => {
    return parentItem.children;
  });
};
